import { z } from "zod";
import { UnitFactorSchema } from "./parameters-counter.js";

export const CreateProductRequestSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  unit: z.string().min(1).max(20),
  // Spec 081 — o produto é dono da equivalência. `countingUnit` é a unidade em que ele é CONTADO
  // (pacote, caixa, kg), que não é necessariamente a de venda; `unitFactor` diz quanto vale uma
  // unidade contada na unidade da linha. Obrigatórios: sem eles toda conversão viraria palpite.
  countingUnit: z.string().min(1).max(20),
  unitFactor: UnitFactorSchema,
  pricePerUnit: z.number().positive(),
});
export type CreateProductRequest = z.infer<typeof CreateProductRequestSchema>;

export const UpdateProductRequestSchema = CreateProductRequestSchema.partial();
export type UpdateProductRequest = z.infer<typeof UpdateProductRequestSchema>;
